import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles<{
  shouldShowCustomeNavButton: boolean
  isExternal?: boolean
  isRevampEnable?: boolean
}>()((theme, { shouldShowCustomeNavButton, isExternal, isRevampEnable }) => ({
  appTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: 'auto',
    '&:has([data-testid="team-relationship-breadcrumb"])': {
      height: theme.spacing(3.375),
      minHeight: theme.spacing(3.375),
      '& > [data-testid="actions"]': {
        height: theme.spacing(3.375),
        paddingTop: 0,
      },
    },
  },
  appTitleHeading: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    '&:has([data-testid="team-relationship-breadcrumb"])': {
      height: theme.spacing(3.375),
    },
  },
  appTitleHeadingText: {
    fontSize: isRevampEnable ? '24px' : '28px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: isRevampEnable ? '32px' : '36px',
    color: theme.palette.labraText.primary,
    '&:has([data-testid="team-relationship-breadcrumb"])': {
      display: 'flex',
      alignItems: 'center',
      fontSize: theme.spacing(2.25),
      fontWeight: 500,
      lineHeight: theme.spacing(3.375),
      height: theme.spacing(3.375),
    },
  },
  stickyContainer: {
    position: 'sticky',
    ...(isRevampEnable && !isExternal
      ? {
          top: 0,
          zIndex: 99,
        }
      : {}),
  },
  action: {
    display: 'flex',
    justifyContent: 'row',
    paddingTop: shouldShowCustomeNavButton
      ? theme.spacing(0)
      : theme.spacing(1.125),
    alignItems: 'center',
    gap: '32px',
    height: theme.spacing(isRevampEnable ? 4 : 5.5),
    boxSizing: 'border-box',
  },
  headerContainer: {
    display: 'inline-flex',
    flexDirection: 'column',
    alignItems: 'flexStart',
    gap: '32px',
    ...(isRevampEnable
      ? {
          padding: theme.spacing(2, 5),
          backgroundColor: theme.palette.text.white,
          boxShadow: `0px -1px 0px 0px ${theme.palette.labraV2BoxShadow.dark} inset`,
        }
      : {
          padding: theme.spacing(4, 5),
        }),
    zIndex: 105,
  },
  subTitleText: {
    fontSize: '14px !important',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px !important',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
  },
  appBackIcon: {
    display: 'flex',
    margin: 'auto',
    marginRight: theme.spacing(1.12),
    cursor: 'pointer',
  },
  customNavButton: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },

  stickyHeaders: {
    position: 'relative',
    height: '23px',
    zIndex: 999,
  },
}))
